import React, { PureComponent } from 'react';

class ButtonExpandir extends PureComponent {
    constructor(props) {
        super(props);
        this.onClickExpandirRow = this.onClickExpandirRow.bind(this);
    }

    onClickExpandirRow(event) {
        this.props.expandirRow(this.props.id);
    }

    render() {
        const { claseFlecha } = this.props;
        return (<a className={"SeccionIngresos__ajuste__trianguloMarginLeft Margin__left__seccionRenglonesModelo__renglonModelo__trianguloDown " + claseFlecha} aria-hidden="true" onClick={this.onClickExpandirRow}></a>);
    }
}

export default ButtonExpandir;